import form from './form.js';
import index from './index.js';
import { Router } from '@/legacy/Router';

Router.get('price/:any', form);
Router.get('price', index);
